import {
  ROOT,
  BOOKING_GROUP_GET_ALL,
  GET_ALL_GROUP_PROFILE,
  GET_BOOOKING_GROUPS,
  BOOKING_GROUP_EXPORT,
  CREATE_GROUP_PROFILE,
  UPDATE_GROUP_PROFILE,
  GET_DETAIL_GROUP_PROFILE,
  DELETE_GROUP_PROFILE,
  UPDATE_BOOKING_GROUP,
  GET_DETAIL_BOOKING_GROUP,
  SEARCH_GROUP_PROFILE,
  GET_TITLE
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

function getAllBooking(params) {
  return fetch(ROOT + BOOKING_GROUP_GET_ALL, requestOptions.post(params))
    .then(handleResponse);
}

function getAllGroupProfile() {
  return fetch(ROOT + GET_ALL_GROUP_PROFILE, requestOptions.get())
    .then(handleResponse);
}

function searchGroupProfile() {
  return fetch(ROOT + SEARCH_GROUP_PROFILE, requestOptions.get())
    .then(handleResponse);
}
// function exportBooking(params) {
//   return fetch(ROOT + BOOKING_EXPORT, requestOptions.post(params))
//     .then(handleResponse);
// }

function exportBooking(params) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + BOOKING_GROUP_EXPORT, requestOptions.post(params))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}

function deleteGroupProfile(code) {
  return fetch(ROOT + DELETE_GROUP_PROFILE + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function getDetailBookingGroup(code) {
  return fetch(ROOT + GET_DETAIL_BOOKING_GROUP + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function getDetailProfile(code) {
  return fetch(ROOT + GET_DETAIL_GROUP_PROFILE + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function getbookingGroups() {
  return fetch(ROOT + GET_BOOOKING_GROUPS, requestOptions.get())
    .then(handleResponse);
}

function updateGroupProfile(params) {
  return fetch(ROOT + UPDATE_GROUP_PROFILE, requestOptions.post(params))
    .then(handleResponse);
}

function createGroupProfile(params) {
  return fetch(ROOT + CREATE_GROUP_PROFILE, requestOptions.post(params))
    .then(handleResponse);
}

function updateBooking(body) {
  return fetch(ROOT + UPDATE_BOOKING_GROUP, requestOptions.post(body))
    .then(handleResponse);
}


function getTitle() {
  return fetch(ROOT + GET_TITLE, requestOptions.get())
    .then(handleResponse);
}
export const service = {
  getAllBooking,
  getbookingGroups,
  createGroupProfile,
  updateGroupProfile,
  getDetailProfile,
  deleteGroupProfile,
  getAllGroupProfile,
  getDetailBookingGroup,
  updateBooking,
  exportBooking,
  searchGroupProfile,
  getTitle
};